/**
 * Timezones used in the application
 */
export const timezones = [
  { value: 'UTC-12', label: 'International Date Line West' },
  { value: 'UTC-11', label: 'Coordinated Universal Time-11' },
  { value: 'UTC-10', label: 'Hawaii' },
  { value: 'UTC-9', label: 'Alaska' },
  { value: 'UTC-8', label: 'Pacific Time (US & Canada)' },
  { value: 'UTC-7', label: 'Mountain Time (US & Canada)' },
  { value: 'UTC-6', label: 'Central Time (US & Canada)' },
  { value: 'UTC-5', label: 'Eastern Time (US & Canada)' },
  { value: 'UTC-4', label: 'Atlantic Time (Canada)' },
  { value: 'UTC-3', label: 'Buenos Aires, Georgetown' },
  { value: 'UTC-2', label: 'Mid-Atlantic' },
  { value: 'UTC-1', label: 'Azores' },
  { value: 'UTC', label: 'Dublin, Edinburgh, Lisbon, London' },
  { value: 'UTC+1', label: 'Brussels, Copenhagen, Madrid, Paris' },
  { value: 'UTC+2', label: 'Athens, Bucharest, Istanbul' },
  { value: 'UTC+3', label: 'Moscow, St. Petersburg, Volgograd' },
  { value: 'UTC+4', label: 'Abu Dhabi, Muscat' },
  { value: 'UTC+5', label: 'Islamabad, Karachi, Tashkent' },
  { value: 'UTC+5:30', label: 'Chennai, Kolkata, Mumbai, New Delhi' },
  { value: 'UTC+5:45', label: 'Kathmandu' },
  { value: 'UTC+6', label: 'Astana, Dhaka' },
  { value: 'UTC+6:30', label: 'Yangon (Rangoon)' },
  { value: 'UTC+7', label: 'Bangkok, Hanoi, Jakarta' },
  { value: 'UTC+8', label: 'Beijing, Chongqing, Hong Kong, Urumqi' },
  { value: 'UTC+9', label: 'Osaka, Sapporo, Tokyo' },
  { value: 'UTC+9:30', label: 'Adelaide, Darwin' },
  { value: 'UTC+10', label: 'Canberra, Melbourne, Sydney' },
  { value: 'UTC+11', label: 'Magadan, Solomon Is., New Caledonia' },
  { value: 'UTC+12', label: 'Auckland, Wellington' },
  { value: 'UTC+13', label: "Nuku'alofa" },
];
